import axios from "axios";

import { CATEGORIES } from "../../configs/api-config";

// Api calls
function get_categories_api() {
  return axios.get(CATEGORIES);
}

export { get_categories_api };
// old

export default {
  get_categories: get_categories_api,
};
